import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class DomainGuard implements CanActivate {
    private isDarbiDomain = this.detectDarbiDomain();

    constructor(private router: Router) {}

    private detectDarbiDomain(): boolean {
        return window.location.hostname.startsWith('darbi');
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // If on darbi domain, only allow:
        // - /work-timer
        // - /auth (for login/forgot-pass flows)
        if (this.isDarbiDomain) {
            const url: string = state.url;
            const isAllowedPath: boolean = url.startsWith('/work-timer') || url.startsWith('/auth');

            if (!isAllowedPath) {
                this.router.navigate(['/work-timer']);
                return false;
            }
        }

        return true;
    }
}
